import { Text, Flex, Image, Button, Divider } from "@chakra-ui/react";
import { DotLottieReact } from "@lottiefiles/dotlottie-react";
import { useIsSmallBreakpoint } from "../../utils/useBreakpoints";
import { FunnelComponentProps } from "../../components/funnel/types";

export function BlackFridayCongratsBody({
  onSuccess,
  customCongratsImage,
}: FunnelComponentProps & {
  customCongratsImage?: string;
}) {
  const isSmall = useIsSmallBreakpoint();
  return (
    <Flex flexDirection="column" alignItems="center" width="100%">
      <Flex marginY="24px" px="24px" flexDirection="column">
        <Text
          variant="onboardingTitle"
          textAlign="center"
          fontSize="24px"
          mb="8px"
        >
          You're now a Gold Member!
        </Text>
        <Text variant="onboardingTitle" textAlign="center" fontSize="20px">
          Your ultimate comics journey starts now.
        </Text>
      </Flex>
      <Image
        src={
          customCongratsImage ??
          `${window.gc.global.assets_url}/static/images/web-ui/black-friday/black_friday_covers_2.png`
        }
        marginTop="-30px"
        width="100%"
        height="auto"
        aspectRatio="512/300"
      />
      <Flex
        marginTop="-45px"
        flexDirection="column"
        gap="24px"
        width="100%"
        px={isSmall ? "24px" : "48px"}
      >
        <Divider color="transparent.white.10" />
        <Button
          // id="btnOnboardingStartReading"
          variant="primary"
          size="lg"
          onClick={() => onSuccess({})}
          width="100%"
        >
          Go back to the app
        </Button>
      </Flex>
      <DotLottieReact
        src={`${window.gc.global.assets_url}/static/images/web-ui/stars_confetti.json`}
        style={{
          position: "absolute",
          top: "0",
          left: "0",
          width: "100%",
          height: "100%",
          pointerEvents: "none",
        }}
        autoplay
      />
    </Flex>
  );
}
